import { useEffect } from 'react';
import { getEnvironmentConfiguration } from '../../app/environments/environment-configuration';

const GoogleAnalytics = () => {
    const apiConfiguration = getEnvironmentConfiguration();

    const appendScript = (scriptToAppend: string) => {
        const script = document.createElement("script");
        script.src = scriptToAppend;
        script.async = true;
        document.body.appendChild(script);
    }

    useEffect(() => {
        if (apiConfiguration.GoogleAnalyticsKey) {
            appendScript(`https://www.googletagmanager.com/gtag/js?id=${apiConfiguration.GoogleAnalyticsKey}`);
            const script = document.createElement("script");
            script.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${apiConfiguration.GoogleAnalyticsKey}');`;
            document.body.appendChild(script);
        }
    });
    

    return null;
};

export default GoogleAnalytics;
